<template>
  <div class="flex items-center lg:flex-col space-x-4">
    <div class="flex flex-col w-2/5 lg:w-full">
      <h2 class="text-32px xs:text-2xl font-bold text-left mb-5">
        {{ $t('video_interview.test-record') }}
      </h2>
      <p class="text-neutral-50 text-base xs:text-sm text-left mb-5">
        {{ $t('video_interview.make-test-record') }}
      </p>
    </div>
    <VideoRecorder class="w-3/5 lg:w-full" @finish-video-record="onFinish"/>
  </div>
</template>
<script>
import VideoRecorder from '@/components/Global/VideoRecorder.vue';

export default {
  name: 'TestVideo',
  components: {
    VideoRecorder,
  },
  methods: {
    onFinish() {
      this.$emit('finish-video-test');
    },
  },
};
</script>
<style lang="scss">
</style>
